import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

import { listRuleOutputs } from "./actions";

export const ruleOutputsEntityAdapter = createEntityAdapter({
  selectId: (ruleOutput) => ruleOutput.uniqueId,
});

const initialState = ruleOutputsEntityAdapter.getInitialState({
  totalRuleCount: 0,
  totalRuleExecutionsCount: 0,
  executionTimedOut: false,
});

export const ruleOutputsSlice = createSlice({
  name: "ruleOutputs",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listRuleOutputs.pending, (state, _) => {
      ruleOutputsEntityAdapter.setAll(state, []);
      state.totalRuleCount = null;
      state.totalRuleExecutionsCount = null;
    });
    builder.addCase(listRuleOutputs.fulfilled, (state, action) => {
      if (action?.payload?.status) {
        const updatedResults =
          action.payload?.executions?.result.map((output) => ({
            ...output,
            uniqueId: uuidv4(),
          })) || [];

        ruleOutputsEntityAdapter.setAll(state, updatedResults);
        state.totalRuleCount = action.payload?.executions?.totalRuleCount;
        state.totalRuleExecutionsCount = action.payload?.executions?.totalRuleExecutionsCount;
        state.executionTimedOut = action.payload?.executions?.executionTimedOut;
      }
    });
  },
});

export default ruleOutputsSlice.reducer;
